{{user}}'s report

<app-doughnut-chart [user] = user> </app-doughnut-chart>